import type { BoardState } from './board'

// Presentation only: saved coordinates and structured-play timing retain their
// original model. Shorten the empty middle of the court in the whiteboard view.
export function whiteboardDimensions(fullCourt = false) {
  return { width: 760, height: fullCourt ? 1110 : 560 }
}

export function whiteboardViewport(board: BoardState) {
  const size = whiteboardDimensions(board.fullCourt)
  const width = size.width + 72, height = size.height + 72
  const points = [...board.players, ...board.strokes.flatMap(s => s.points),
    ...board.play?.initialPlayers || [], ...board.play?.steps.flatMap(s => s.movements.flatMap(m => m.points)) || []]
  if (board.looseBall) points.push(board.looseBall)
  let factor = 1
  for (const p of points) {
    if (!Number.isFinite(p.x) || !Number.isFinite(p.y)) continue
    factor = Math.max(factor, (Math.abs(p.x * size.width - size.width / 2) + 30) / (width / 2),
      (Math.abs(p.y * size.height - size.height / 2) + 30) / (height / 2))
  }
  return { x: (size.width - width * factor) / 2, y: (size.height - height * factor) / 2,
    width: width * factor, height: height * factor }
}

export function fitWhiteboard(width: number, height: number, view: { width: number; height: number }) {
  const scale = Math.min(width / view.width, height / view.height)
  return { width: Math.min(width, view.width * scale * 1.2), height: view.height * scale }
}
